
<template lang="html">

  <div class="main-container">


     <section class="mobile">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="masthead-logo-mobile mobile">
              <img :src="'static/img/common/logo.png'" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <mast-head
      ref="mst" 
      page="takeaway"
    >
    </mast-head>

    <section>
      <div class="container"> 
        <div class="row intro-box">
          <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center">
<!--             <p class="mobile" v-html="home.subtitle"></p> -->
            <h3 class="h3-subtitle"  v-html="takeaway.subtitle"></h3>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <p v-for="(p, index) in takeaway.body" class="page-paragraph" v-html="p"></p>
         
            <a :href="takeaway.menu_link" class="router-link-container" download><link-button :label="takeaway.menu_button"></link-button></a>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <p v-for="(p, index) in takeaway.body2" class="page-paragraph" v-html="p"></p>
            <a :href="'mailto:'+takeaway.order_email" class="router-link-container"><link-button :label="takeaway.order_button"></link-button></a>
          </div>
        </div>
      </div>
    </section>




    <!-- <section class="mobile">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="masthead-logo-mobile mobile">
              <img :src="'static/img/common/logo.png'" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <mast-head
        ref="mst" 
        page="takeaway"
        >
    </mast-head>
      
    <section id="about-section">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-10 col-md-offset-1 text-center">
            <h1 class="h1-title" v-html="takeaway.title"></h1>
            <h3 class="h3-subtitle h3-subtitle-padded" v-html="takeaway.subtitle"></h3>
            <p class="page-paragraph" v-for="(p, index) in takeaway.body" v-html="p"></p>
            <a :href="'mailto:'+takeaway.order_email" class="router-link-container" to="/projects"><link-button :label="takeaway.order_button"></link-button></a>
          </div>
        </div>
      </div>
    </section> -->

<!--     <section>
      <div class="container"> 
        <div class="row intro-box">
          <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center">
            <h3 class="h3-subtitle"  v-html="canteen.subtitle"></h3>
          </div>
        </div>
      </div>
    </section> -->

<!--     <section>
      <my-carousel
        :array="'food_array'"
      ></my-carousel>    
    </section> -->

<!--     <section>
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <p v-for="(p, index) in canteen.body" class="page-paragraph" v-html="p"></p>
          </div>
        </div>
      </div>
    </section> -->

    <section>
      <contact-section></contact-section>
    </section>

    <section class="section-joined-bottom">
      <text-ticker page="food"></text-ticker>
    </section>

    <section class="section-joined-top">
      <footer-image></footer-image>
    </section>
  </div>

</template>

<style type="text/css" scoped>
  
  

</style>

<script>

// var dataURL = 'https://api.ralphandco.com/updates'
import MastHead from '../components/MastHead'
import {commontools} from '../mixins/Styling'
import LinkButton from '../components/LinkButton'
import FooterImage from '../components/FooterImage'
import TextTicker from '../components/TextTicker'
import ContactSection from '../components/ContactSection'
import MyCarousel from '../components/MyCarousel.vue'
import {takeaway} from '../../content.json'

export default {
  mixins: [commontools],
  name: 'takeaway',
  watch: {
    '$route.name': function (id) {
      window.scrollTo(0, 0)
    }
  },
  data () {
    return {
      takeaway,
      metatitle: '',
      loadCounter: 0
    }
  },
  methods: {
  },
  created: function () {

  },
  mounted: function () {
    window.scrollTo(0, 0)
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {
    MastHead,
    LinkButton,
    FooterImage,
    TextTicker,
    ContactSection,
    MyCarousel
  }
}
</script>


// WEBPACK FOOTER //
// Takeaway.vue?11e97bd2